import React from 'react';
import { MedicalDataTypes } from '../../../../../../primary-record-types';
import { useIsFocused } from '@react-navigation/native';
import LinkedList from './LinkedList';
import SuggestLinks from './SuggestLinks';
import RelatedResourceList from '../RelatedResourceListTab';
import SuggestedAdditions from './SuggestedAdditions';

export type RelatedResourceListV2OwnProps = {
    sourceResourceCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
    relatedResourceCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
    hasEditPermission: boolean;
    relatedResources: MedicalDataTypes.PrimaryRecordResource[];
    isLoadingRelatedResources: boolean;
    profileId: string;
    sourceResourceId: string;
};

export type RelatedResourceListV2Props = RelatedResourceListV2OwnProps;

type Mode = 'suggest-links' | 'suggest-add' | 'linked-list' | 'manual-link';

const RelatedResourceListV2: React.FC<RelatedResourceListV2Props> = (props) => {
    const [mode, setMode] = React.useState<Mode>('linked-list');

    // Reset mode to default anytime the screen is focused
    const isFocused = useIsFocused();
    React.useEffect(() => {
        if (isFocused) {
            setMode('linked-list');
        }
    }, [isFocused]);

    if (mode === 'linked-list') {
        return (
            <LinkedList
                {...props}
                onLink={() => {
                    setMode('suggest-links');
                }}
            />
        );
    } else if (mode === 'suggest-links') {
        return (
            <SuggestLinks
                {...props}
                onSuggestAdditions={() => {
                    setMode('suggest-add');
                }}
                onShowRelatedList={() => {
                    setMode('linked-list');
                }}
                onManualLink={() => {
                    setMode('manual-link');
                }}
            />
        );
    } else if (mode === 'suggest-add') {
        return (
            <SuggestedAdditions
                {...props}
                onShowRelatedList={() => {
                    setMode('linked-list');
                }}
                onManualLink={() => {
                    setMode('manual-link');
                }}
            />
        );
    } else if (mode === 'manual-link') {
        return <RelatedResourceList {...props} />;
    }
};

export default React.memo(RelatedResourceListV2);
